import { render, staticRenderFns } from "./exitOutboundHistory.vue?vue&type=template&id=62d881a4&scoped=true&"
import script from "./exitOutboundHistory.vue?vue&type=script&lang=js&"
export * from "./exitOutboundHistory.vue?vue&type=script&lang=js&"
import style0 from "./exitOutboundHistory.vue?vue&type=style&index=0&id=62d881a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d881a4",
  null
  
)

export default component.exports